// TO SAGAS
export const SEND_FRIENDS_REQUEST = 'my_friends/SEND_FRIEND_REQUEST';
export const LOAD_FRIENDS = 'my_friends/GET_FRIENDS';

// STATE SETTERS
export const SET_SEND_FRIEND_REQUEST_WAITING =
  'my_friends/SET_SEND_FRIEND_REQUEST_WAITING';
export const SET_SEND_FRIEND_REQUEST_MESSAGE =
  'my_friends/SET_SEND_FRIEND_REQUEST_MESSAGE';
export const SET_SEND_FRIEND_REQUEST_SUCCESS =
  'my_friends/SET_SEND_FRIEND_REQUEST_SUCCESS';
export const SET_LOAD_FRIENDS_WAITING = 'my_friends/SET_LOAD_FRIENDS_WAITING';
export const SET_TOTAL_FRIENDS_COUNT = 'my_friends/SET_TOTAL_FRIENDS_COUNT';
export const SET_FRIENDS = 'my_friends/SET_FRIENDS';

// STATE
export const REMOVE_FRIEND = 'my_friends/REMOVE_FRIEND';
export const SET_REMOVE_FRIEND_WAITING = 'my_friends/SET_REMOVE_FRIEND_WAITING';
export const SET_REMOVE_FRIEND_SUCCESS = 'my_friends/SET_REMOVE_FRIEND_SUCCESS';
export const SET_REMOVE_FRIEND_MESSAGE = 'my_friends/SET_REMOVE_FRIEND_MESSAGE';
export const REMOVE_FRIEND_FROM_LOCAL_LIST =
  'my_friends/REMOVE_FRIEND_FROM_LOCAL_LIST';

// RESOLVE FRIEND REQUEST
export const RESOLVE_FRIEND_REQUEST = 'my_friends/RESOLVE_FRIEND_REQUEST';
export const SET_RESOLVE_FRIEND_REQUEST_WAITING =
  'my_friends/SET_RESOLVE_FRIEND_REQUEST_WAITING';
export const SET_RESOLVE_FRIEND_REQUEST_SUCCESS =
  'my_friends/SET_RESOLVE_FRIEND_REQUEST_SUCCESS';
export const SET_RESOLVE_FRIEND_REQUEST_MESSAGE =
  'my_friends/SET_RESOLVE_FRIEND_REQUEST_MESSAGE';
export const RESET_FRIENDS_OBJECT = 'my_friends/RESET_FRIENDS_OBJECT';

// GET & SET REQUEST NOTIFICATIONS
export const SET_FRIEND_REQUEST_NOTIFICATIONS =
  'SET_FRIEND_REQUEST_NOTIFICATIONS';
export const LOAD_FRIEND_REQUEST_NOTIFICATIONS =
  'LOAD_FRIEND_REQUEST_NOTIFICATIONS';
